import { Link } from 'react-router';
import { ROUTES } from '@/shared/config/routes';
import { Button } from '@/shared/ui/button';
import { Pill } from '@/shared/ui/pill';

type TestPodActionsProps = {
  isPassed: boolean;
  isFailed: boolean;
  isRunning: boolean;
  onRun: () => void;
};

export function TestPodActions({ isPassed, isFailed, isRunning, onRun }: TestPodActionsProps) {
  if (isPassed) {
    return (
      <div className="flex flex-wrap items-center gap-3">
        <Pill tone="ok" size="lg" hasDot>
          Your Pod works
        </Pill>
        <Button asChild variant="primary" size="lg">
          <Link to={ROUTES.OVERVIEW}>Go to Overview</Link>
        </Button>
      </div>
    );
  }
  const label = isRunning ? 'Booting a Pod…' : isFailed ? 'Try again' : 'Run a test Pod';
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button variant="primary" size="lg" isLoading={isRunning} onClick={onRun}>
        {label}
      </Button>
      <Button asChild variant="ghost" size="lg">
        <Link to={ROUTES.OVERVIEW}>Skip for now</Link>
      </Button>
    </div>
  );
}
